import $ from "jquery";
import { getCookie, setCookie } from "../lib/cookies";

const cookiename = "showed-learn-modal";
$(function () {
  if (typeof hbspt === "undefined") {
    console.error("HubSpot script not loaded");
    return;
  }

  // Get cookie value
  const cookieValue = getCookie(cookiename);

  if (cookieValue === "true") {
    // Cookie exists, do nothing
    return;
  }

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#hsform_learnmore",
    formId: "800c0b10-79c7-41d5-a152-073714462e1b",
    onFormReady: function ($form) {
      $("#zip-800c0b10-79c7-41d5-a152-073714462e1b").attr("maxlength", "5");
      $form
        .find("#npi__10_digit_-800c0b10-79c7-41d5-a152-073714462e1b")
        .attr("maxlength", "10");
      $('select[name="specialty"]', $form)
        .find("option")
        .each(function () {
          if (!$(this).val()) {
            $(this).text("Select");
          }
        });
        $('#label-npi__10_digit_-800c0b10-79c7-41d5-a152-073714462e1b span', $form).text("NPI");
        setTimeout(function () {
          // set cookie
          setCookie(cookiename, "true", 7);
          $("#modal_learn_more").modal("show");
        }, 5000);
    },
    onFormSubmit: function ($form) {
      // Prevent the default form submit action which causes the scroll to top
      $form.on('submit', function (e) {
        e.preventDefault();
        // Perform any additional actions you want here
      });
    },

    onFormSubmitted: function ($form) {
      // Prevent scrolling to the top after form submission
      $form.closest('.modal-body').scrollTop($form.closest('.hs-form').offset().top);
    }
  });
});
